import { Box } from '@mui/material';
import theme from 'theme/theme';
import { Model } from '../../hooks/useModelState';
import ModelDrawerTrigger from '../../ModelDrawerTrigger';
import { SceneProps } from '../scene-utils';
import { Scene } from '../types';
import sideDrawerContentFunction from './ScenarioManagerSceneSideDrawer';

const TITLE = 'SCENARIO MANAGER';

const ScenarioManagerDisplay = ({ props }: { props: SceneProps }) => (
  <>
    {!props.context.state.drawerOpen && (
      <Box sx={{ position: 'absolute', right: theme.spacing(2), zIndex: 20 }}>
        <ModelDrawerTrigger handleClick={() => props.context.actions.setDrawerOpen(true)} />
      </Box>
    )}
  </>
);

const ScenarioManagerScene = (props: SceneProps): Scene => {
  const display = () => <ScenarioManagerDisplay props={props} />;

  const getCanvasHandlers = () => ({
    onNodeHover: () => { },
    onNodeSelect: () => { },
    onSpoolSelect: () => { },
  });

  const sideDrawerContent = (model: Model) => sideDrawerContentFunction(props, model);

  const onExit = () => { };

  return {
    key: props.key,
    display,
    getCanvasHandlers,
    sideDrawerContent,
    onExit,
    title: TITLE,
    actionButtons: [],
  };
};

export default ScenarioManagerScene;
